import { ItemTypeMap } from '../../../../components/blackrock/advisor-center/_types/item';
import { Tab } from '../../../../components/blackrock/advisor-center/_types/tab';
import {
	NetworkErrorConfig,
	NoResultConfig,
} from '../../../../components/blackrock/advisor-center/empty-state/EmptyStateProps';
import { SeriesItemData } from '../../../../components/blackrock/advisor-center/cards/series-item-card/SeriesItemCardProps';
import { SaveConfig } from '../../../../components/blackrock/advisor-center/save/SaveButtonProps';
import { CallToAction } from '../../../../components/blackrock/advisor-center/cta/model.ts';

export type DynamicContentListData = {
	componentTitle?: string;
	componentDescription?: string;
	translationMap: TranslationData;
	iconMap: ItemTypeMap<string>;
	authorList: string[];
	topicMap: TopicMap;
	tabs: Tab[];
	secondTabTopic?: string;
	variant: DynamicContentVariant;
	callToAction?: CallToAction;
	articleImageList: string[];
	documentImageList: string[];
	networkErrorConfig: NetworkErrorConfig;
	noResultConfig: NoResultConfig;
	saveConfig: SaveConfig | null;
	filterDisabled: boolean;
	sortDisabled: boolean;
	contentList: SeriesItemData[];
};

export type TranslationData = {
	loadMoreButton: string;
	writtenBy: string;
	readMore: string;
	sort: SortTranslation;
	types: { ALL: string } & ItemTypeMap<string>;
	filter: {
		label: string;
		titleForDesktop: string;
		titleForMobileSingle: string;
		titleForMobilePlural: string;
		categoryTitles: {
			types: string;
			authors: string;
			topics: string;
			publications: string;
		};
		cancel: string;
		clearAll: string;
		submitForDesktopSingle: string;
		submitForDesktopPlural: string;
		submitForMobile: string;
		ariaLabelCloseButton: string;
		ariaLabelForCategory: string;
		ariaStatusSingle: string;
		ariaStatusPlural: string;
		ariaLabelDialog: string;
		otherAuthors: string;
	};
};

export type SortTranslation = {
	byLabel: string;
	ascending: string;
	descending: string;
	publishedDate: string;
	authors: string;
};

export const DYNAMIC_CONTENT_VARIANTS = ['dashboard', 'insights'] as const;
export type DynamicContentVariant = (typeof DYNAMIC_CONTENT_VARIANTS)[number];

export type TopicMap = {
	[key: string]: string;
};

export type FallbackImages = Partial<ItemTypeMap<string[]>> & {
	default: string[];
};

export interface FallbackImagesSource {
	articleImageList: string[];
	documentImageList: string[];
}

export enum SortTypes {
	publishedDate = 'publishedDate',
	authors = 'authors',
}
